export default __webpack_public_path__ + "static/media/pre-details-header.f3327ef5.png";